import React, {FC} from 'react';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {reportToBugsnag} from '../../../../../srcCommon/services/bugsnag/bugsnag';
import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {DelegationModel} from '../../../../models/api/delegationModel';
import {AppState} from '../../../../store/appState';
import {getDelegations} from '../../../../store/data/delegations/delegationsSelectors';
import {InboxesPanelId} from '../../../../store/panels/panelStateBase';
import {WorkspaceDragItem} from '../dnd/workspaceDragDropTypes';
import {DelegationWorkspaceContainer} from './delegationWorkspaceContainer';

/*
 * Props.
 */

interface MaybeDelegationWorkspaceContainerProps {
  delegationId: DelegationModel['id'];
  workspaceDragItem?: WorkspaceDragItem;
  panelId: InboxesPanelId;
}

interface MaybeDelegationWorkspaceContainerComponentProps {
  delegation: DelegationModel | undefined;
  workspaceDragItem?: WorkspaceDragItem;
  panelId: InboxesPanelId;
}

/*
 * Selectors.
 */

function getDelegationId(_state: AppState, props: MaybeDelegationWorkspaceContainerProps) {
  return props.delegationId;
}

function makeGetDelegation() {
  return createSelector([getDelegationId, getDelegations], (delegationId, delegations) => {
    const delegation = delegations[delegationId];
    if (!delegation) {
      reportToBugsnag(new Error('Cannot find delegation in state to show in workspace'), {
        metadata: {delegationId},
      });
    }
    return delegation;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<MaybeDelegationWorkspaceContainerProps>()(() => ({
  delegation: makeGetDelegation(),
}));

const MaybeDelegationWorkspaceContainerComponent: FC<MaybeDelegationWorkspaceContainerComponentProps> = (
  props,
) => {
  const {delegation, panelId, workspaceDragItem} = props;
  return delegation ? (
    <DelegationWorkspaceContainer
      delegation={delegation}
      panelId={panelId}
      workspaceDragItem={workspaceDragItem}
    />
  ) : null;
};

export const MaybeDelegationWorkspaceContainer = connect(mapStateToProps)(
  MaybeDelegationWorkspaceContainerComponent,
);
